"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShowHideShadow = exports.RightInnerShadow = exports.BottomRightInnerShadow = void 0;
const react_1 = require("react");
const styled_1 = __importDefault(require("@emotion/styled"));
const Shadow = (0, styled_1.default)('div') `
  bottom: 0;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.2s ease-out;
`;
exports.BottomRightInnerShadow = (0, styled_1.default)(Shadow) `
  box-shadow: -1em -3em 3em -1em white inset;
`;
exports.RightInnerShadow = (0, styled_1.default)(Shadow) `
  box-shadow: -1em -0em 3em -1em white inset;
`;
function useShowHideShadow({ ref, getPopupElem, setShadowType }) {
    const init = (0, react_1.useRef)(false);
    (0, react_1.useLayoutEffect)(() => {
        if (init.current) {
            return;
        }
        const elem = getPopupElem();
        if (elem) {
            init.current = true;
            let ticking = false;
            // add a shadow
            if (elem && elem.scrollHeight > elem.clientHeight) {
                setShadowType('rightBottom');
            }
            else {
                setShadowType('right');
            }
            // based on scroll position displays/hides the bottom shadow
            const handleScroll = () => {
                const buffer = 40;
                if (!ticking) {
                    window.requestAnimationFrame(function () {
                        const diff = Math.abs(elem.scrollHeight - elem.clientHeight);
                        if (ref.current) {
                            if (elem.scrollTop > diff - buffer) {
                                ref.current.style.opacity = '0';
                            }
                            else {
                                ref.current.style.opacity = '1';
                            }
                        }
                        ticking = false;
                    });
                    ticking = true;
                }
            };
            elem.addEventListener('scroll', handleScroll, { passive: true });
            return () => {
                elem.removeEventListener('scroll', handleScroll);
                init.current = false;
            };
        }
        return;
    });
}
exports.useShowHideShadow = useShowHideShadow;
//# sourceMappingURL=Shadow.js.map